var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ExchangeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 5 C 16.838262 5 11 10.838262 11 18 L 11 29.878906 L 7.5605469 26.439453 A 1.50015 1.50015 0 0 0 6.484375 25.984375 A 1.50015 1.50015 0 0 0 5.4394531 28.560547 L 11.310547 34.431641 A 1.50015 1.50015 0 0 0 13.697266 34.423828 L 19.560547 28.560547 A 1.50015 1.50015 0 1 0 17.439453 26.439453 L 14 29.878906 L 14 18 C 14 12.459738 18.459738 8 24 8 C 26.59565 8 28.93698 8.9889501 30.71875 10.609375 A 1.50015 1.50015 0 1 0 32.736328 8.390625 C 30.432098 6.2950499 27.36235 5 24 5 z M 35.476562 12.978516 A 1.50015 1.50015 0 0 0 34.300781 13.578125 L 28.439453 19.439453 A 1.50015 1.50015 0 1 0 30.560547 21.560547 L 34 18.121094 L 34 30 C 34 35.540262 29.540262 40 24 40 C 21.40435 40 19.06302 39.01105 17.28125 37.390625 A 1.50015 1.50015 0 1 0 15.263672 39.609375 C 17.567902 41.70495 20.63765 43 24 43 C 31.161738 43 37 37.161738 37 30 L 37 18.121094 L 40.439453 21.560547 A 1.50015 1.50015 0 1 0 42.560547 19.439453 L 36.689453 13.568359 A 1.50015 1.50015 0 0 0 35.476562 12.978516 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ExchangeSmall);
export default __webpack_public_path__ + "static/media/icons8-exchange-small.5928a818c4278c832ffb178458307bab.svg";
export { ForwardRef as ReactComponent };